import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const carTrackingRequirementSelector = selector<boolean>({
    key: 'carTrackingRequirementSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const { fixedId } = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        if (!jobNumber) throw new Error('Invalid jobId');
        if (!sessionId) throw new Error('Invalid sessionId');
        if (!fixedId) throw new Error('Invalid coverableFixedId');

        return await OnlineSalesUnauthenticated.getCarIsTrackingRequired(
            jobNumber,
            sessionId,
            fixedId,
            !isLoggedOn
        );
    }
});
